<template>
  <AuthFailure>
    <template #textSlot>
      <h2 style='max-width:750px'>У вас нет доступа к данному разделу или сайту.<br />Пожалуйста, авторизуйтесь под другой учетной записью</h2>
    </template>
  </AuthFailure>
</template>

<script>
import AuthFailure from "@/components/auth-failure/AuthFailure.vue";

export default {
  name: "Forbidden",
  components: { AuthFailure },
  metaInfo() {
    return {
      title: `Доступ к данному ресурсу ограничен - ЛУКМАРКЕТ`,
    };
  },
};
</script>

<style scoped></style>
